// FIXME import this from barrel will break the app
import { BitfDefaultResponseMapper } from '../default-parser/bitf-default-response.mapper';
export class BitfMockDbResponseMapper extends BitfDefaultResponseMapper {}
